import React from 'react'
import styles from './FeaturesSection.module.css'

const FeaturesSection = ({ isActive }) => {
  const features = [
    {
      iconClass: 'fas fa-brain',
      color: '#8B5CF6',
      title: 'AI 심리 분석',
      description: 'HTP, DAP 등 검증된 미술치료 기법을 기반으로 한 과학적 분석',
      details: [
        '색상, 선, 배치 패턴 분석',
        '스토리텔링 기반 결과 제공',
        '개인화된 추천 시스템'
      ]
    },
    {
      iconClass: 'fas fa-heart',
      color: '#EF4444',
      title: '체계적 치유 코스',
      description: '5일로 구조화된 프로그램으로 단계적 성장',
      details: [
        '개인 맞춤 커리큘럼',
        '진행 상황 시각화',
        '감정 여정 리포트'
      ]
    },
    {
      iconClass: 'fas fa-paint-brush',
      color: '#10B981',
      title: '간편한 드로잉',
      description: '디지털 캔버스와 다양한 브러시, 레이어 기능',
      details: [
        '벡터 기반 고품질 저장',
        '작업 과정 추적 기능',
        '다양한 색상과 도구'
      ]
    },
    {
      iconClass: 'fas fa-users',
      color: '#F59E0B',
      title: '커뮤니티',
      description: '작품 공유, 일상적 대화, 감정 공유를 통한 성장 경험',
      details: [
        '인기 게시물 시스템',
        '추천 및 댓글 시스템',
        '다양한 그림 공유 및 감상'
      ]
    },
    {
      iconClass: 'fas fa-book',
      color: '#8B5CF6',
      title: '감정 일기장',
      description: '매일의 감정을 기록하고 AI가 분석하여 당신의 감정 변화를 추적',
      details: [
        '감정 선택 및 일기 작성',
        'AI 기반 감정 분석 및 인사이트',
        '달력으로 한눈에 보는 감정 기록'
      ]
    },
    {
      iconClass: 'fas fa-trophy',
      color: '#06B6D4',
      title: '게임화 & 보상 (준비중)',
      description: '단순한 보상 그 이상, 매일 도전할 수 있는 다양한 게임 요소로 동기부여',
      details: [
        '일일/주간 미션 → 랭킹/리더보드',
        '포인트 획득 → 아바타 아이템 획득',
        '도전과 성취를 통한 장기적인 몰입감'
      ]
    }
  ]

  return (
    <div className={`${styles.featuresSection} ${isActive ? styles.active : ''}`}>
      <div className={styles.container}>
        <header className={styles.header}>
          <h2 className={styles.title}>여러 기능을 한 곳에 모으다.</h2>
          <p className={styles.subtitle}>AI 분석부터 재미있는 게임화까지, 그림으로 경험하는 모든 것</p>
        </header>

        <div className={styles.featuresGrid}>
          {features.map((feature, index) => (
            <div 
              key={index} 
              className={styles.featureCard}
              style={{ 
                '--feature-color': feature.color,
                '--animation-delay': `${index * 0.1}s`
              }}
            >
              <div className={styles.featureHeader}>
                <div className={styles.featureIcon}>
                  <i className={feature.iconClass}></i>
                </div>
                <h3 className={styles.featureTitle}>{feature.title}</h3>
              </div>
              
              <p className={styles.featureDescription}>
                {feature.description}
              </p>
              
              <ul className={styles.featureDetails}>
                {feature.details.map((detail, detailIndex) => (
                  <li key={detailIndex} className={styles.featureDetail}>
                    <i className="fas fa-check"></i>
                    {detail}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default FeaturesSection